import React from 'react'
import { connect } from 'react-redux'
import NavigationDesktop from '../Components/NavigationDesktop'

const NavigationDesktopContainer = (props) => <NavigationDesktop {...props} />

const mapStateToProps = (state) => {
    return {
        links: state.navigation.contentLinks,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(NavigationDesktopContainer)
